<template>
  <div class="form-header">
    <img src="../../assets/img/logo_color.png" alt="Mashup logo">
    <div class="section-title">
      <h2 v-if="this.title === 'login'">{{$t('auth.login.title')}}</h2>
      <h2 v-else-if="this.title === 'signup'">{{$t('auth.signup.title')}}</h2>
      <h2 v-else-if="this.title === 'partner'">{{$t('auth.partner.signup.title')}}</h2>
    </div>
  </div>
</template>

<script>

export default {
  name: 'component-header',
  props: {
   title: {
    type: String,
    required: true
   }
  }
}    
</script>